import { render, staticRenderFns } from "./facture-forfaitaire.html?vue&type=template&id=634bb050&scoped=true&external"
import script from "./facture-forfaitaire.js?vue&type=script&lang=js&external"
export * from "./facture-forfaitaire.js?vue&type=script&lang=js&external"
import style0 from "./facture-forfaitaire.scss?vue&type=style&index=0&id=634bb050&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bb050",
  null
  
)

export default component.exports